<div class="pointCF__content">
  <pp-datepicker
    class="timelineCF__datepicker"
    [ppDateMultiple]="value"
    (ppSelect)="updateDate($event)"
    ppPlaceholder="From / To"
    [ppMultipleDatesInput]="true"
    [ppDisabled]="ppReadOnly"
    [ppIsLocked]="ppLocked"
  ></pp-datepicker>
</div>

@if (!ppReadOnly && !ppUpdating) {
  <button class="pointCF__clear" (click)="clearCustomField()">&#xd7;</button>
}
